import React, { useState } from "react";
import AuthLayout from "../customComponent/AuthLayout";
import { useNavigate } from "react-router";
import { useDispatch } from "react-redux";
import { resetPassword } from "../../redux/action/Auth/ForgetPasswordAction";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import { TextField } from "@mui/material";

const ForgetPassword = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [error, setError] = useState(null);

  // const validationSchema = Yup.object().shape({
  //   email: Yup.string()
  //     .email("Invalid email address")
  //     .required("Email is required"),
  // });

    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

    const validationSchema = Yup.object().shape({
      email: Yup.string()
        .matches(emailRegex, "Invalid email address format")
        .required("Email is required"),
    });
  const handleForgetPassword = async (values, { setSubmitting, setErrors }) => {
    try {
      await dispatch(resetPassword(values.email));
      localStorage.setItem("resetPasswordEmail", values.email);
      navigate("/reset-link");
    } catch (err) {
      console.log("coonsole error ", err?.response?.data?.message);
      // const staticErrorMessage =
      //   "An error occurred while processing your request. Please write a correct email.";
      // setErrors({ email: staticErrorMessage });
      setError(err?.response?.data?.message);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <AuthLayout
      title="Forgot Password?"
      description="Don't worry, happens to all of us. Enter your email below to reset your password."
      form={
        <Formik
          initialValues={{ email: "" }}
          validationSchema={validationSchema}
          onSubmit={handleForgetPassword}
        >
          {({ isSubmitting, errors, touched }) => (
            <Form className="space-y-4 md:space-y-6">
              <div>
                <Field name="email">
                  {({ field }) => (
                    <TextField
                      fullWidth
                      {...field}
                      label="Email"
                      error={touched.email && Boolean(errors.email)}
                      errorMessage={touched.email && errors.email}
                      helperText={touched.email && errors.email}
                    />
                  )}
                </Field>
                {/* <ErrorMessage
                  name="email"
                  component="div"
                  className="text-red-600"
                /> */}
                {error && <div className="text-red-500 mt-2">{error}</div>}
              </div>
              <button
                type="submit"
                disabled={isSubmitting}
                className="w-full bg-blue-900 text-white py-2 px-4 rounded-md hover:bg-blue-800 transition duration-300"
              >
                Forgot Password
              </button>
            </Form>
          )}
        </Formik>
      }
    />
  );
};

export default ForgetPassword;
